import { useState } from "react";
import { Modal, Button, Select, Form, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import "./CreateUpdateCatalogueItemPhone.css";

const { Option } = Select;

const CreateUpdateCatalogueItem = () => {
  const { catalogueStore } = useMobxStores();
  const [form_create_update_catalogue_item] = Form.useForm();

  const onCreateUpdateItem = async (fields) => {
    if (fields.source) {
      let cleaned = fields.source.trim();

      if (!cleaned.startsWith("https://")) {
        const wwwIndex = cleaned.indexOf("www.");
        if (wwwIndex !== -1) {
          cleaned = cleaned.slice(wwwIndex);
        }
        cleaned = `https://${cleaned}`;
      }

      fields.source = cleaned;
    }

    if (catalogueStore.updateModeOn) {
      await catalogueStore.UpdateCatalogueItemById(fields);
    } else {
      await catalogueStore.CreateCatalogueItem(fields);
    }

    form_create_update_catalogue_item.resetFields();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      catalogueStore.setIsCatalogueModalOpen(false);
    }, 2000);
  };

  const handleCancel = () => {
    catalogueStore.setIsCatalogueModalOpen(false);
    catalogueStore.setupdateModeOn(false);
    form_create_update_catalogue_item.resetFields();
  };

  const types = [
    {
      label: "Marketplace Asset",
      value: "Marketplace Asset",
    },
    {
      label: "Software Repository",
      value: "Software Repository",
    },
    {
      label: "MOOC",
      value: "MOOC",
    },
  ];

  const levels = [
    {
      label: "Beginner",
      value: "beginner",
    },
    {
      label: "Intermediate",
      value: "intermediate",
    },
    {
      label: "Advanced",
      value: "advanced",
    },
    // {
    //   label: "Expert",
    //   value: "expert",
    // },
  ];

  return (
    <div>
      <Modal
        title={
          catalogueStore.updateModeOn
            ? "Update catalogue item"
            : "Create Catalogue Item"
        }
        open={catalogueStore.isCatalogueModalOpen}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={null}
        width={"80%"}
        style={{ textAlign: "center", marginTop: "-60px" }}
        className="create-catalogue-modal"
      >
        <Form
          form={form_create_update_catalogue_item}
          name="form_create_update_catalogue_item"
          onFinish={onCreateUpdateItem}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          fields={catalogueStore.catalogueDetails}
          layout="vertical"
          size="large"
          initialValues={{
            resetFields: true,
          }}
        >
          <Form.Item
            label="Title"
            name="title"
            rules={[
              {
                required: true,
                message: "Please input a title!",
              },
            ]}
          >
            <Input
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder="Title"
              maxLength={100}
              showCount
            />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: true,
                message: "Please input a description!",
              },
            ]}
          >
            <Input
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder="Description"
            />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type"
            rules={[
              {
                required: true,
                message: "Please input a type!",
              },
            ]}
          >
            <Select
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder={"Type"}
            >
              {types.map((item, index) => {
                return (
                  <Option key={index} value={item.value}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Source"
            name="source"
            rules={[
              {
                required: true,
                message: "Please input a source!",
                type: "url",
              },
            ]}
          >
            <Input
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder="Source"
            />
          </Form.Item>
          <Form.Item
            label="Learning outcome"
            name="educational_outcome"
            rules={[
              {
                max: 200,
                message: "Learning outcome must be 200 characters or fewer.",
              },
            ]}
          >
            <Input
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder="Learning outcome"
              maxLength={200}
              showCount
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Level&nbsp;
                <Tooltip
                  title={
                    <div>
                      <div>Beginner → Understand / Apply</div>
                      <div>Intermediate → Analyze</div>
                      <div>Advanced → Evaluate / Create</div>
                    </div>
                  }
                >
                  <InfoCircleOutlined style={{ fontSize: "14px" }} />
                </Tooltip>
              </span>
            }
            name="level"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Select
              style={{
                height: "32px",
                fontSize: "16px",
              }}
              placeholder="Level"
            >
              {levels.map((level, index) => (
                <Option key={index} value={level.value}>
                  {level.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 24,
            }}
          >
            <Button
              style={{
                marginTop: "12px",
                fontSize: "18px",
                height: "30px",
              }}
              type="primary"
              htmlType="submit"
            >
              {catalogueStore.updateModeOn ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default observer(CreateUpdateCatalogueItem);
